import {
  LayoutDashboard, Users, Trees, Tractor, ClipboardList, CalendarDays, ShoppingCart,
  HardHat, Percent, Wifi, FileText, BarChart3, Settings, Package, Boxes, Wallet,
} from "lucide-react";

export const MODULE_META = {
  dashboard: { icon: LayoutDashboard, desc: "Visão geral do seu dia e atalhos rápidos." },
  clientes: { icon: Users, desc: "Cadastro de produtores rurais e seus contatos." },
  fazendas: { icon: Trees, desc: "Propriedades, áreas em hectares, localização e histórico." },
  equipamentos: { icon: Tractor, desc: "Tratores, implementos, sistemas e histórico de manutenção." },
  "ordens-servico": { icon: ClipboardList, desc: "Abertura, execução e acompanhamento das OS de campo." },
  agenda: { icon: CalendarDays, desc: "Visitas técnicas, manutenções e serviços programados." },
  produtos: { icon: Package, desc: "Produtos disponíveis para venda." },
  estoque: { icon: Boxes, desc: "Estoque geral, estoque de cada técnico e alertas de mínimo." },
  financeiro: { icon: Wallet, desc: "Faturamento, contas a pagar/receber, comissões e recibos." },
  vendas: { icon: ShoppingCart, desc: "Pedidos, orçamentos e vendas." },
  colaboradores: { icon: HardHat, desc: "Equipe técnica, administradores e acessos." },
  comissoes: { icon: Percent, desc: "Cálculo e acompanhamento de comissões." },
  "fazenda-conectada": { icon: Wifi, desc: "Sensores, telemetria e monitoramento remoto." },
  documentos: { icon: FileText, desc: "Laudos, contratos, manuais e certificados." },
  relatorios: { icon: BarChart3, desc: "Relatórios gerenciais e de desempenho." },
  configuracoes: { icon: Settings, desc: "Perfil, senha, identidade visual e permissões." },
};

export const ROLE_SCOPE = {
  admin: "Você tem acesso completo a todos os registros.",
  tecnico: "Você vê as ordens de serviço designadas a você e suas comissões.",
  financeiro: "Você acompanha faturamento, contas, comissões e pagamentos.",
  cliente: "Cadastre suas fazendas e equipamentos, peça atendimento e veja nossos produtos.",
};

export const ROLE_LABEL = { admin: "Administrador", tecnico: "Colaborador/Técnico", cliente: "Cliente", financeiro: "Financeiro" };

export const BOTTOM_PRIORITY = ["dashboard", "ordens-servico", "agenda", "comissoes", "financeiro", "fazendas", "produtos", "equipamentos"];
